import { ChangeDetectorRef, Directive, DoCheck, inject, input } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive()
export abstract class WithReadonly implements DoCheck {
  readonly readonly = input(false);
  readonly readonlyValue = input<string>();

  readonly ngControl = inject(NgControl, { self: true, optional: true });

  protected readonly changeDetectorRef = inject(ChangeDetectorRef);
  private lastControlValue: unknown;

  constructor() {
    if (this.ngControl) {
      // trick it into thinking control has a valueAccessor, we don't need it because child has
      this.ngControl.valueAccessor = {
        writeValue(): void {
          // do nothing
        },
        registerOnChange(): void {
          // do nothing
        },
        registerOnTouched(): void {
          // do nothing
        },
      };
    }
  }

  // A parent that reset()s or patchValue()s the bound control changes nothing an OnPush host sees as an input.
  ngDoCheck(): void {
    const value = this.ngControl?.value;
    if (value !== this.lastControlValue) {
      this.lastControlValue = value;
      this.changeDetectorRef.markForCheck();
    }
  }
}
